import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import CustomFieldInput from 'app/shared/components/customFields/CustomFieldsSection/components/CustomFieldInput';
import { isManualRequired } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.utils';
import PropTypes from 'prop-types';

import { sectionFieldsStyles, sectionStyles } from '../../EnterCustomFieldsModal.styles';

const EnterCustomFieldsModalTargetSection = ({
  sectionKey,
  subHeader = null,
  definitions,
  formValues = null,
  errors = null,
  isDisabled = false,
  onFieldChange,
  onFieldBlur,
}) => {
  const onChange = useCallback(
    (definitionId, nextValue) => {
      onFieldChange({ sectionKey, definitionId, value: nextValue });
    },
    [onFieldChange, sectionKey],
  );

  const onBlur = useCallback(
    definitionId => {
      onFieldBlur({ sectionKey, definitionId });
    },
    [onFieldBlur, sectionKey],
  );

  return (
    <Box sx={sectionStyles}>
      {!!subHeader && (
        <Typography component="h6" variant="medium14">
          {subHeader}
        </Typography>
      )}
      <Box sx={sectionFieldsStyles}>
        {definitions.map(definition => (
          <CustomFieldInput
            dataTestId={`enter-custom-fields-${sectionKey}-${definition.id}`}
            definition={definition}
            disabled={isDisabled}
            errorKey={errors?.[definition.id]}
            key={definition.id}
            required={isManualRequired(definition)}
            value={formValues?.[definition.id] ?? ''}
            onBlur={onBlur}
            onChange={onChange}
          />
        ))}
      </Box>
    </Box>
  );
};

EnterCustomFieldsModalTargetSection.propTypes = {
  sectionKey: PropTypes.string.isRequired,
  definitions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  subHeader: PropTypes.string,
  formValues: PropTypes.object,
  errors: PropTypes.object,
  isDisabled: PropTypes.bool,
};

export default memo(EnterCustomFieldsModalTargetSection);
